import React, { Component } from 'react';

import { Mixpanel } from './Mixpanel';

import settings from '../data/settings_meresankh_zh-hans.json';
import translations from '../data/translations.json';


interface Props {
}

interface State {
}

export class BookPrivateTourButton extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
  }


  render() {

    return (
      <div className="pointer-events-auto px-6 w-full">
        <a href="https://mused.typeform.com/to/aiMysXsf" className="block w-full" target="_blank" rel="noopener noreferrer">
          <span className="cursor-pointer flex items-center justify-center bg-white hover:bg-theme-100 py-2 px-2 w-full max-w-2xl rounded-lg shadow-xl text-xs uppercase font-sans-bold text-theme-700 pointer-events-auto">
            {translations[settings.language]['Book a Private Tour']}
          </span>
        </a>
        <span className="hidden sm:block text-xs sm:text-sm mt-1">
          {translations[settings.language]['Book a Private Tour with an Egyptologist in-person at Giza']}
        </span>
      </div>
    );
  }
}
